import { render } from "./editDealerGroup.vue?vue&type=template&id=04ba7d4e"
import script from "./editDealerGroup.vue?vue&type=script&lang=js"
export * from "./editDealerGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__